(function () {
  'use strict';

  const CARD_SELECTOR = '.ProductItem';
  const productCache = new Map();

  let activeRun = 0;
  let updateTimer = null;
  let observer = null;
  let lastHash = window.location.hash;

  function normalize(value) {
    return String(value || '')
      .replace(/\$2520/gi, ' ')
      .replace(/%2520/gi, ' ')
      .replace(/%20/gi, ' ')
      .replace(/\+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function decodeFilterValue(value) {
    let decoded = String(value || '');

    decoded = decoded
      .replace(/\$25/gi, '%')
      .replace(/%25/gi, '%');

    try {
      decoded = decodeURIComponent(decoded);
    } catch (error) {
      // Continue with the unescaped value.
    }

    try {
      decoded = decodeURIComponent(decoded);
    } catch (error) {
      // Value was only encoded once.
    }

    return decoded
      .replace(/\$2520/gi, ' ')
      .replace(/%2520/gi, ' ')
      .replace(/%20/gi, ' ')
      .replace(/\+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getSelectedStone() {
    const hash = window.location.hash || '';

    const match = hash.match(
      /filter:variant_stone:([^/]+)/i
    );

    if (!match || !match[1]) {
      return '';
    }

    return decodeFilterValue(match[1]).split(/[|,]/)[0].trim();
  }

  function getPrimaryImage(card) {
    return (
      card.querySelector(
        '.ProductItem__Image:not(.ProductItem__Image--alternate)'
      ) ||
      card.querySelector('.ProductItem__Image') ||
      card.querySelector('picture img') ||
      card.querySelector('img')
    );
  }

  function getPictureSources(image) {
    if (!image) {
      return [];
    }

    const picture = image.closest('picture');

    return picture
      ? Array.from(picture.querySelectorAll('source'))
      : [];
  }

  function getProductLinks(card) {
    return Array.from(
      card.querySelectorAll('a[href*="/products/"]')
    );
  }

  function getHandle(card) {
    const link = card.querySelector('a[href*="/products/"]');

    if (!link) {
      return '';
    }

    const match = link.href.match(/\/products\/([^/?#]+)/i);

    return match ? match[1] : '';
  }

  function saveElementAttribute(element, attribute) {
    if (!element) {
      return;
    }

    const key =
      'faceoutOriginal' +
      attribute
        .replace(/-([a-z])/g, function (_, letter) {
          return letter.toUpperCase();
        })
        .replace(/^./, function (letter) {
          return letter.toUpperCase();
        });

    if (element.dataset[key + 'Saved'] === 'true') {
      return;
    }

    element.dataset[key + 'Saved'] = 'true';
    element.dataset[key] =
      element.getAttribute(attribute) || '';
  }

  function restoreElementAttribute(element, attribute) {
    if (!element) {
      return;
    }

    const key =
      'faceoutOriginal' +
      attribute
        .replace(/-([a-z])/g, function (_, letter) {
          return letter.toUpperCase();
        })
        .replace(/^./, function (letter) {
          return letter.toUpperCase();
        });

    if (element.dataset[key + 'Saved'] !== 'true') {
      return;
    }

    const originalValue = element.dataset[key];

    if (originalValue) {
      element.setAttribute(attribute, originalValue);
    } else {
      element.removeAttribute(attribute);
    }
  }

  function saveOriginalState(card) {
    const image = getPrimaryImage(card);

    if (image) {
      [
        'src',
        'srcset',
        'sizes',
        'data-src',
        'data-srcset',
        'alt'
      ].forEach(function (attribute) {
        saveElementAttribute(image, attribute);
      });

      getPictureSources(image).forEach(function (source) {
        [
          'src',
          'srcset',
          'data-src',
          'data-srcset'
        ].forEach(function (attribute) {
          saveElementAttribute(source, attribute);
        });
      });
    }

    getProductLinks(card).forEach(function (link) {
      saveElementAttribute(link, 'href');
    });
  }

  function restoreCard(card) {
    const image = getPrimaryImage(card);

    if (image) {
      [
        'src',
        'srcset',
        'sizes',
        'data-src',
        'data-srcset',
        'alt'
      ].forEach(function (attribute) {
        restoreElementAttribute(image, attribute);
      });

      getPictureSources(image).forEach(function (source) {
        [
          'src',
          'srcset',
          'data-src',
          'data-srcset'
        ].forEach(function (attribute) {
          restoreElementAttribute(source, attribute);
        });
      });
    }

    getProductLinks(card).forEach(function (link) {
      restoreElementAttribute(link, 'href');
    });

    card.removeAttribute('data-faceout-stone');
    card.removeAttribute('data-faceout-variant');
  }

  async function fetchProduct(handle) {
    if (!handle) {
      return null;
    }

    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const request = fetch(
      root + 'products/' + handle + '.js',
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Could not load ' +
              handle +
              ': ' +
              response.status
          );
        }

        return response.json();
      })
      .catch(function (error) {
        console.warn('[Athos variant faceout]', error);
        productCache.delete(handle);
        return null;
      });

    productCache.set(handle, request);

    return request;
  }

  function variantMatchesStone(variant, selectedStone) {
    if (!variant || !selectedStone) {
      return false;
    }

    const target = normalize(selectedStone);

    const exactOptionMatch = (
      variant.options || []
    ).some(function (option) {
      return normalize(option) === target;
    });

    if (exactOptionMatch) {
      return true;
    }

    const optionFields = [
      variant.option1,
      variant.option2,
      variant.option3
    ];

    const directOptionMatch = optionFields.some(function (option) {
      return normalize(option) === target;
    });

    if (directOptionMatch) {
      return true;
    }

    const titleParts = String(variant.title || '').split(
      /\s*\/\s*/
    );

    return titleParts.some(function (part) {
      return normalize(part) === target;
    });
  }

  function getVariantImageUrl(variant) {
    if (!variant) {
      return '';
    }

    if (typeof variant.featured_image === 'string') {
      return variant.featured_image;
    }

    if (
      variant.featured_image &&
      variant.featured_image.src
    ) {
      return variant.featured_image.src;
    }

    if (
      variant.featured_image &&
      variant.featured_image.url
    ) {
      return variant.featured_image.url;
    }

    return '';
  }

  function cleanImageUrl(imageUrl) {
    if (!imageUrl) {
      return '';
    }

    if (imageUrl.indexOf('//') === 0) {
      return window.location.protocol + imageUrl;
    }

    return imageUrl;
  }

  function createSrcset(imageUrl) {
    return [
      imageUrl + ' 360w',
      imageUrl + ' 540w',
      imageUrl + ' 720w',
      imageUrl + ' 900w',
      imageUrl + ' 1200w'
    ].join(', ');
  }

  function forceImage(card, imageUrl, altText) {
    const image = getPrimaryImage(card);

    if (!image || !imageUrl) {
      return;
    }

    const cleanUrl = cleanImageUrl(imageUrl);
    const srcset = createSrcset(cleanUrl);

    /*
     * Update every <source> inside the surrounding <picture>.
     * Otherwise the browser can continue displaying the Sapphire source.
     */
    getPictureSources(image).forEach(function (source) {
      source.setAttribute('src', cleanUrl);
      source.setAttribute('srcset', srcset);
      source.setAttribute('data-src', cleanUrl);
      source.setAttribute('data-srcset', srcset);
    });

    image.setAttribute('src', cleanUrl);
    image.setAttribute('srcset', srcset);
    image.setAttribute('data-src', cleanUrl);
    image.setAttribute('data-srcset', srcset);

    if (altText) {
      image.setAttribute('alt', altText);
    }

    /*
     * Remove lazy-load classes that can reapply the original image.
     */
    image.classList.remove(
      'lazyload',
      'lazyloading'
    );

    image.classList.add('lazyloaded');

    /*
     * Reapply after the current browser render in case Athos finishes
     * updating the card immediately after this function.
     */
    window.requestAnimationFrame(function () {
      getPictureSources(image).forEach(function (source) {
        source.setAttribute('src', cleanUrl);
        source.setAttribute('srcset', srcset);
        source.setAttribute('data-src', cleanUrl);
        source.setAttribute('data-srcset', srcset);
      });

      image.setAttribute('src', cleanUrl);
      image.setAttribute('srcset', srcset);
      image.setAttribute('data-src', cleanUrl);
      image.setAttribute('data-srcset', srcset);
    });
  }

  function addVariantToUrl(originalHref, variantId) {
    if (!originalHref || !variantId) {
      return originalHref;
    }

    try {
      const url = new URL(
        originalHref,
        window.location.origin
      );

      url.searchParams.set('variant', variantId);

      if (originalHref.charAt(0) === '/') {
        return url.pathname + url.search + url.hash;
      }

      return url.toString();
    } catch (error) {
      return originalHref;
    }
  }

  async function updateCard(card, stone, runNumber) {
    saveOriginalState(card);
    restoreCard(card);

    if (!stone) {
      return;
    }

    const handle = getHandle(card);

    if (!handle) {
      return;
    }

    const product = await fetchProduct(handle);

    if (runNumber !== activeRun || !product) {
      return;
    }

    const variant = (
      product.variants || []
    ).find(function (item) {
      return variantMatchesStone(item, stone);
    });

    if (!variant) {
      console.warn(
        '[Athos variant faceout] No matching variant:',
        product.title,
        stone
      );

      return;
    }

    const imageUrl = getVariantImageUrl(variant);

    if (imageUrl) {
      forceImage(
        card,
        imageUrl,
        product.title + ' – ' + variant.title
      );
    } else {
      console.warn(
        '[Athos variant faceout] Variant has no image:',
        product.title,
        variant.title
      );
    }

    getProductLinks(card).forEach(function (link) {
      const originalHref =
        link.dataset.faceoutOriginalHref ||
        link.getAttribute('href') ||
        '';

      link.setAttribute(
        'href',
        addVariantToUrl(originalHref, variant.id)
      );
    });

    card.dataset.faceoutStone = stone;
    card.dataset.faceoutVariant = String(variant.id);
  }

  async function updateFaceouts() {
    const runNumber = ++activeRun;
    const selectedStone = getSelectedStone();

    const cards = Array.from(
      document.querySelectorAll(CARD_SELECTOR)
    );

    await Promise.all(
      cards.map(function (card) {
        return updateCard(
          card,
          selectedStone,
          runNumber
        );
      })
    );
  }

  function scheduleUpdate(delay) {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(function () {
      updateFaceouts();
    }, typeof delay === 'number' ? delay : 100);
  }

  function runUpdateSequence() {
    /*
     * Athos changes the URL first and finishes rendering afterward.
     * These passes catch both moments without leaving the old faceout.
     */
    activeRun += 1;

    scheduleUpdate(50);

    window.setTimeout(function () {
      updateFaceouts();
    }, 300);

    window.setTimeout(function () {
      updateFaceouts();
    }, 800);

    window.setTimeout(function () {
      updateFaceouts();
    }, 1500);
  }

  function preloadProducts() {
    const preload = function () {
      const handles = new Set();

      document
        .querySelectorAll(CARD_SELECTOR)
        .forEach(function (card) {
          const handle = getHandle(card);

          if (handle) {
            handles.add(handle);
          }
        });

      handles.forEach(fetchProduct);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preload, {
        timeout: 1500
      });
    } else {
      window.setTimeout(preload, 500);
    }
  }

  function watchHash() {
    window.setInterval(function () {
      if (window.location.hash !== lastHash) {
        lastHash = window.location.hash;
        runUpdateSequence();
      }
    }, 150);
  }

  function startObserver() {
    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(function (mutations) {
      const cardsChanged = mutations.some(function (mutation) {
        return Array.from(
          mutation.addedNodes || []
        ).some(function (node) {
          if (node.nodeType !== 1) {
            return false;
          }

          return (
            (node.matches &&
              node.matches(CARD_SELECTOR)) ||
            (node.querySelector &&
              node.querySelector(CARD_SELECTOR))
          );
        });
      });

      if (cardsChanged) {
        scheduleUpdate(100);
        preloadProducts();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    runUpdateSequence();
    preloadProducts();
    startObserver();
    watchHash();

    window.addEventListener(
      'hashchange',
      runUpdateSequence
    );

    window.addEventListener(
      'popstate',
      runUpdateSequence
    );

    document.addEventListener('click', function (event) {
      const filterControl = event.target.closest(
        'input[type="checkbox"], ' +
          '[class*="filter"], ' +
          '[class*="Filter"], ' +
          '[data-filter]'
      );

      if (filterControl) {
        runUpdateSequence();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }
})();